import HelpContainer from '@ua/help-container';

(function ($) {
  const bots = {
    GODADDY_MVP: {
      botProjectId: 'mirabot-dccab'
    },
    REQUEST_A_CALL: {
      botProjectId: 'helpmechoose-bot'
    },
    ROUTING: {
      botProjectId: 'escalation-bot-236018',
      welcomeIntent: 'Welcome'
    },
    SURVEY: {
      botProjectId: 'css-survey-bot'
    }
  };
  const activeBot = bots.ROUTING;

  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
      return parts[1].split(';').shift();
    }
  }

  function getVisitorGuId() {
    var visitor = getCookie('visitor');
    if (visitor && visitor.length > 4) {
      return visitor.split('=')[1];
    }
  }

  function getVisitGuid() {
    return getCookie('pathway');
  }

  function ready() {
    var helpContainer = $('#help-container');
    if (helpContainer.length) {

      let env = requestContext.env;
      if (env === 'dev') env = 'development';
      if (env === 'prod') env = 'production';

      ReactDOM.render(React.createElement(HelpContainer, {
        affordance: false,
        env,
        market: 'en-US',
        product: requestContext.searchScopeId,
        shopperId: requestContext.shopperId,
        standalone: true,
        tabs: ['browse', 'contact'],
        visitorId: getVisitorGuId() || getVisitGuid(),
        welcomeIntent: activeBot.welcomeIntent
      }), helpContainer[0]);

    }
  }

  $(document).ready(ready);

}(jQuery));
